import React from 'react';
import FilterOptionsButton from 'components/FilterOptionsButton/index';

const FilterTags = props => {
  const { tags, onRemoveTagFilter } = props;
  const filtersKeys = Object.keys(tags);

  return filtersKeys?.map(key => {
    const filterValue = tags[key].value;
    const filterLabel = tags[key].label;

    if (filterValue && filterLabel) {
      return (
        <FilterOptionsButton
          values={[filterValue]}
          onChange={onRemoveTagFilter}
          options={[tags[key]]}
          defaultValue={filterValue}
          className="margL8 m-margL0 m-margB8"
          keyFilter={key}
        />
      );
    } else {
      return '';
    }
  });
};

export default FilterTags;
